<template lang="pug">
  .col-24.initBackgroundImage.flexD.alignItemsCenter.justifyCenter.l-padding-top-8em.l-padding-bottom-4em.m-padding-top-4em.m-padding-bottom-2em(:style="{backgroundImage:'url('+ img.bg +')', backgroundSize: 'contain'}")
    .col-12.flexD.flexDirectionColumn.minWidth700.m-minWidthAuto.m-width-100
      .col-24.flexD.justifyCenter.l-margin-bottom-4em
        .col-6.m-width-40
          img.col-24.block(:src="img.logo")
      .col-24.l-margin-bottom-4em.m-padding-left-right-5p
        .font-section.textAlignLeft(v-for="(item, index) in text.section" :key="index") {{ item.content }}
      .col-24.msFlexNegative
        video.block.col-24(:src="video.whd" controls="controls" :poster="img.poster")
</template>

<script>
  export default {
    name: 'whd',
    props: ['content'],
    data(){
      return{
        text: {
          section: [
            { content: this.$t('whd.content_1') },
            { content: this.$t('whd.content_2') },
          ]
        },
        img: {
          bg: require('@/assets/img/bg_whd.png'),
          logo: require('@/assets/img/logo/logo_whd.png'),
          poster: require('@/assets/img/cover_whd.jpg'),
        },
        video: {
          whd: require('@/assets/media/whd.mp4')
        }
      }
    },
    computed: {},
    methods:{},
    created(){}
  }
</script>
